import React from "react";
import { Container, Typography, Box } from "@mui/material";

const ReturnPolicy = () => {
  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Typography
        variant="h3"
        component="h1"
        gutterBottom
        align="center"
        sx={{ fontWeight: 100, mb: 10, mt: 25 }}
      >
        Return Policy
      </Typography>

      <Box sx={{ mb: 4 }}>
        <Typography variant="h5" gutterBottom sx={{ fontWeight: 400 }}>
          Return and Exchange Policy
        </Typography>
        <Typography color="text.secondary">
          We have a 7-day return policy, which means you have 7 days after
          receiving your item to request a return. To be eligible for a return,
          your item must be in the same condition that you received it, unworn
          or unused, with tags, and in its original packaging. You’ll also need
          the receipt or proof of purchase. To start a return, you can contact
          us at contact@dainasoul.com. If your return is accepted, we’ll send
          you a return shipping label, as well as instructions on how and where
          to send your package. Items sent back to us without first requesting a
          return will not be accepted. You can always contact us for any return
          question at contact@dainasoul.com.
        </Typography>
      </Box>

      <Box sx={{ mb: 4 }}>
        <Typography variant="h5" gutterBottom sx={{ fontWeight: 400 }}>
          Restocking Fee
        </Typography>
        <Typography color="text.secondary">
          Please be kind and treat our products with respect. They have feelings
          too. A 20% restocking fee may apply, if the item(s) are not returned
          in their original condition.
        </Typography>
      </Box>

      <Box sx={{ mb: 4 }}>
        <Typography variant="h5" gutterBottom sx={{ fontWeight: 400 }}>
          Refunds
        </Typography>
        <Typography color="text.secondary">
          We will notify you once we’ve received and inspected your return, and
          let you know if the refund was approved or not. If approved, you’ll be
          automatically refunded on your original payment method. Please
          remember it can take some days time for your bank or credit card
          company to process and post the refund too.
        </Typography>
      </Box>

      <Box sx={{ mb: 4 }}>
        <Typography variant="h5" gutterBottom sx={{ fontWeight: 400 }}>
          Defective or Damaged Goods
        </Typography>
        <Typography color="text.secondary">
          If your item(s) is defective or damaged upon arrival, you must contact
          us within 15 days of receiving your item(s) for an exchange.
        </Typography>
      </Box>
    </Container>
  );
};

export default ReturnPolicy;
